module.exports = __webpack_public_path__ + "img/1taskStatus.94e0899b.svg";